import Vue from "vue";
import App from "./App.vue";

import router from './router/route-config';
import { store } from './store/store';
import Dialog from 'v-dialogs';

Vue.config.productionTip = false;

export const eventBus = new Vue();
Vue.filter("trim", function(str) {
  return str.replace(/ /g, "");
});

Vue.use(Dialog);

new Vue({
  render: h => h(App),
  router,
  store,
}).$mount("#app");
